import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, LogIn } from 'lucide-react';
import NavIcon from './ui/NavIcon';
import ServicesDropdown from './navigation/ServicesDropdown';
import { services } from '../data/navigation';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed top-4 left-1/2 -translate-x-1/2 w-[95%] max-w-7xl z-50 transition-all duration-300 ${
        isScrolled ? 'py-2' : 'py-4'
      }`}
    >
      <div className={`
        relative bg-white/80 backdrop-blur-lg rounded-2xl shadow-lg
        transition-all duration-300
        ${isScrolled ? 'px-4' : 'px-6'}
      `}>
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://i.imgur.com/zyqapcz.png"
              alt="France Student"
              className="h-12"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            <Link 
              to="/" 
              className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Accueil
            </Link>
            <Link 
              to="/about" 
              className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              À propos
            </Link>
            <ServicesDropdown />
            <Link 
              to="/deals" 
              className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Bons Plans
            </Link>
            <Link 
              to="/team" 
              className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Équipe
            </Link>
            <Link 
              to="/jobs" 
              className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Jobs
            </Link>
            <a
              href="https://my.francestudent.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 px-6 py-2 rounded-lg bg-[#0139B7] text-white hover:bg-opacity-90 transition-colors flex items-center"
            >
              <LogIn className="w-4 h-4 mr-2" />
              Espace Client
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4">
            <div className="flex flex-col space-y-2">
              <Link 
                to="/" 
                className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Accueil
              </Link>
              <Link 
                to="/about" 
                className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                À propos
              </Link>
              <div className="px-4 py-2">
                <div className="font-medium text-gray-700 mb-2">Services</div>
                <div className="grid grid-cols-2 gap-2">
                  {services.map((service) => (
                    <Link
                      key={service.path}
                      to={service.path}
                      className="flex items-center p-2 rounded-lg hover:bg-gray-50 transition-colors"
                      onClick={() => setIsOpen(false)}
                    >
                      <div 
                        className="w-6 h-6 rounded-lg flex items-center justify-center mr-2"
                        style={{
                          backgroundColor: `${service.color}15`,
                          color: service.color
                        }}
                      >
                        <NavIcon name={service.iconName} />
                      </div>
                      <span style={{ color: service.color }}>{service.name}</span>
                    </Link>
                  ))}
                </div>
              </div>
              <Link 
                to="/deals" 
                className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Bons Plans
              </Link>
              <Link 
                to="/team" 
                className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Équipe
              </Link>
              <Link 
                to="/jobs" 
                className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Jobs
              </Link>
              <a
                href="https://my.francestudent.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 rounded-lg bg-[#0139B7] text-white hover:bg-opacity-90 transition-colors flex items-center"
                onClick={() => setIsOpen(false)}
              >
                <LogIn className="w-4 h-4 mr-2" />
                Espace Client
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;